exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.registerForm[data-v-45ea54f8] {\n  margin-top: 120px;\n}\n#searchCountry[data-v-45ea54f8] {\n  margin-top: 0;\n}\n.icon-password[data-v-45ea54f8] {\n  width: 28px;\n  height: 28px;\n}\n.no-gutter[data-v-45ea54f8], .card[data-v-45ea54f8] {\n  margin-left: 0px;\n  margin-right: 0px;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-45ea54f8","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/user/CMRegister.vue
// module id = 1544
// module chunks = 2